// all values are in rem
export const mobileBreakpoint = {
  headerWidth: "80rem",
  reportingPageWidth: "90rem",
};
